import { getCurrentPath } from './getCurrentPath';

export function getCurrentLocale() {
  const url = getCurrentPath();
  if (url.includes("/en/") || url.endsWith("/en")) return "en"
  if (url.includes("/pl/") || url.endsWith("/pl")) return "pl"
  return "en";
}
